import styles from './styles.module.scss'

const DEFAULT_COLORS = ['#0b1020', '#26113d', '#641b48', '#123b4b', '#11121c']

/**
 * Seconds for one drift cycle at speed 1. Each blob multiplies this by its own
 * factor so the layers never realign and the loop stays invisible.
 */
const BASE_DURATION_SECONDS = 3
const DRIFT_MULTIPLIERS = [1, 1.37, 0.82, 1.61, 1.14]

interface Props {
    colors?: readonly string[]
    speed?: number
}

export const MeshGradient = ({ colors = DEFAULT_COLORS, speed = 0.15 }: Props) => {
    const palette = colors.length ? colors : DEFAULT_COLORS
    const animated = speed > 0

    return (
        <div className={styles.wrapper} aria-hidden="true" style={{ backgroundColor: palette[0] }}>
            {palette.map((color, index) => {
                const multiplier = DRIFT_MULTIPLIERS[index % DRIFT_MULTIPLIERS.length]
                return (
                    <span
                        key={`${color}-${index}`}
                        className={styles.blob}
                        style={{
                            backgroundColor: color,
                            animationDuration: animated
                                ? `${((BASE_DURATION_SECONDS / speed) * multiplier).toFixed(2)}s`
                                : undefined,
                            animationPlayState: animated ? undefined : 'paused',
                        }}
                    />
                )
            })}
        </div>
    )
}

export default MeshGradient
